import request from '@/utils/request'

/**
 * 城市运营商管理API
 */

// 获取城市运营商列表
export function getCityOperatorList(params) {
  return request({
    url: '/city-operators',
    method: 'get',
    params
  })
}

// 获取城市运营商详情
export function getCityOperatorDetail(id) {
  return request({
    url: `/city-operators/${id}`,
    method: 'get'
  })
}

// 创建城市运营商
export function createCityOperator(data) {
  return request({
    url: '/city-operators',
    method: 'post',
    data
  })
}

// 更新城市运营商
export function updateCityOperator(id, data) {
  return request({
    url: `/city-operators/${id}`,
    method: 'put',
    data
  })
}

// 审核城市运营商
export function auditCityOperator(id, auditStatus, auditRemark) {
  return request({
    url: `/city-operators/${id}/audit`,
    method: 'put',
    data: {
      auditStatus,
      auditRemark
    }
  })
}

// 删除城市运营商
export function deleteCityOperator(id) {
  return request({
    url: `/city-operators/${id}`,
    method: 'delete'
  })
}

// 城市运营商登录
export function cityOperatorLogin(data) {
  return request({
    url: '/city-operators/login',
    method: 'post',
    data
  })
}

// 批量审核城市运营商
export function batchAuditCityOperators(ids, auditStatus, auditRemark) {
  return request({
    url: '/city-operators/batch-audit',
    method: 'put',
    data: {
      ids,
      auditStatus,
      auditRemark
    }
  })
}

// 获取运营商统计信息
export function getCityOperatorStats() {
  return request({
    url: '/city-operators/stats',
    method: 'get'
  })
}

// 获取当前登录运营商信息
export function getCurrentCity(username) {
  return request({
    url: '/admin/cityOperator/getCurrentCity',
    method: 'get',
    _silent: true,
    params: { username: username || localStorage.getItem('username') || '' }
  })
}
